<template>
  <div class="layout">
    <ym-header class="header"
               :class="[showHeader ? 'active' : '']"
               v-if="inH5Platform && showHeader"
               :title="title"
               :fixed="headerFixed"
               :style="headerStyle"
    >
      <back-btn slot="left"
                v-if="showBack"
                :text="backText"
                :button-style="backStyle"
      />
    </ym-header>

    <div class="router-view">
      <router-view />
    </div>
    <common-coupon-popup :show.sync="showCommonCouponPopup"
                         :info="commonCouponPopupInfo"
    />
  </div>
</template>

<script>
  import { Header } from 'ym-mint-ui';
  import { mapGetters } from 'vuex';
  import BackBtn from '@/components/HeaderBackBtn';
  import CommonCouponPopup from '@/components/CommonCouponPopup';
  import { isPC } from '@/utils';
  import { getCommonCouponPopupInfo } from '@/services/app';

  export default {
    name: 'Layout',
    components: {
      'ym-header': Header,
      BackBtn,
      CommonCouponPopup,
    },
    data() {
      return {
        activityInfo: null,
        certificate: null,
        lessonCompleteListener: null,
        commonCouponPopupInfo: null,
        showCommonCouponPopup: false,
      };
    },
    computed: {
      ...mapGetters([
        'showHeader',
        'title',
        'headerStyle',
        'headerFixed',
        'showBack',
        'backText',
        'backStyle',
        'player',
      ]),
      inH5Platform() {
        return !isPC();
      },
    },
    watch: {
      $route() {
        // 通用优惠券弹窗
        this.getCommonCouponPopupInfo();
      },
    },
    methods: {
      async getCommonCouponPopupInfo() {
        const data = await getCommonCouponPopupInfo(this.$route.name);
        this.commonCouponPopupInfo = data.info;
        this.showCommonCouponPopup = Boolean(data.info);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .layout {
    height: 100vh;
    height: 100%;
  }

  .header {
    font-size: @font-size-large;
    z-index: 10;
    &.is-fixed.active {
      + .router-view {
        padding-top: @header-height;
      }
    }
  }

  .router-view {
    position: relative;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
  }
</style>
